module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"confirm":"Confirm"},"fr":{"confirm":"Valider"},"de":{"confirm":"Bestätigen"}}')
  delete Component.options._Ctor
}
